var _circle, _rect, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFileUpload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Group 5"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 6"
  }, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 10",
    cx: 12,
    cy: 12,
    r: 12,
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    id: "backup"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1867_23158",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 4,
    y: 4,
    width: 16,
    height: 16
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Bounding box",
    x: 4,
    y: 4,
    width: 16,
    height: 16,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1867_23158)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "backup_2",
    d: "M8.33332 17C7.41196 17 6.62607 16.6804 5.97563 16.0412C5.32521 15.4019 5 14.6207 5 13.6974C5 12.8692 5.26646 12.1408 5.79937 11.5122C6.33228 10.8835 6.99317 10.5111 7.78205 10.3949C7.99573 9.39829 8.49679 8.58333 9.28525 7.95C10.0737 7.31667 10.9786 7 12 7C13.2071 7 14.2311 7.42044 15.072 8.26132C15.9129 9.10218 16.3333 10.1262 16.3333 11.3333V11.6667H16.5384C17.241 11.7214 17.8269 12.0038 18.2961 12.5141C18.7653 13.0244 19 13.6308 19 14.3333C19 15.0769 18.7436 15.7072 18.2307 16.2243C17.7179 16.7414 17.0897 17 16.3461 17H12.7051C12.3684 17 12.0833 16.8833 11.85 16.65C11.6167 16.4166 11.5 16.1316 11.5 15.7948V12.1436L10.2666 13.3564L9.5641 12.6602L12 10.2244L14.4359 12.6602L13.7333 13.3564L12.5 12.1436V15.7948C12.5 15.8461 12.5213 15.8931 12.5641 15.9359C12.6068 15.9786 12.6538 16 12.7051 16H16.3333C16.8 16 17.1944 15.8389 17.5166 15.5167C17.8389 15.1944 18 14.8 18 14.3333C18 13.8667 17.8389 13.4722 17.5166 13.15C17.1944 12.8278 16.8 12.6667 16.3333 12.6667H15.3333V11.3333C15.3333 10.4111 15.0083 9.62498 14.3583 8.97498C13.7083 8.32498 12.9222 7.99998 12 7.99998C11.0778 7.99998 10.2916 8.32498 9.64165 8.97498C8.99165 9.62498 8.66665 10.4111 8.66665 11.3333H8.3205C7.68888 11.3333 7.14422 11.5611 6.68652 12.0167C6.22883 12.4722 5.99998 13.0222 5.99998 13.6667C5.99998 14.3111 6.22776 14.8611 6.68332 15.3167C7.13887 15.7722 7.68887 16 8.33332 16H9.99998V17H8.33332Z",
    fill: "#B6B6B6"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFileUpload);
export default __webpack_public_path__ + "static/media/file_upload.98a80dbf3c6ca750239e92f7841067cd.svg";
export { ForwardRef as ReactComponent };